import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { ISTAT_MILANO } from 'shell/constants/istat-milano';

export const MUNICIPALITY_MILANO: MunicipalityAnprVM = {
  description: 'MILANO',
  id: ISTAT_MILANO,
  istatCode: ISTAT_MILANO,
  code: 5646,
  province: 'MI',
  idProvince: 15,
};
